import { render, staticRenderFns } from "./GalleryDetailDefaultLayout.vue?vue&type=template&id=612e8dca&scoped=true"
import script from "./GalleryDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./GalleryDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e8dca",
  null
  
)

export default component.exports